// FieldLabelField.jsx

import React from 'react';

// Components
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';
import TextInput from 'components/textinput/TextInput';

/**
 * FieldLabelField
 *
 * @returns {ReactNode} The rendered component.
 */
const FieldLabelField = ({
    value,
    theme,
    error,
    onChange,
}) => {

  // ----- RENDER ----- //

  return (

    <ModalField>

        <ModalLabel label="Label" />
        <ModalHint hint="The primary label for the field." />

        <TextInput
          value={value}
          maxLength={100}
          autoFocus
          error={!!error}
          helperText={error}
          onChange={(e) => onChange(e.target.value)}
        />

    </ModalField>
);
};

// Dev Tools
FieldLabelField.displayName = 'FieldLabelField';

export default FieldLabelField;
